module.exports = __webpack_public_path__ + "static/media/foryou3.8e16ed85.jpg";